(function () {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const sectionSelector = ".wt-testimonials-marquee__container--ugc, .sonic-animated-slider-arrows, .shopify-section-group-footer-group, .sonic-arrow-button, [data-section-id$='__product_header_usp_bar'], .sonic-product-template-root .wt-product__gallery";
  const buttonSelector = ".wt-slider__nav-btn, .wt-newsletter__send, .sonic-arrow-button";
  const svgNamespace = "http://www.w3.org/2000/svg";
  const arrowGeometry = {
    width: 18.57145,
    height: 15.4286,
    shiftX: 5,
    prevTipX: 5.857143,
    nextTipX: 12.71431,
    midY: 7.7143,
  };

  function getNumericCustomProperty(element, property, fallback) {
    const value = window.getComputedStyle(element).getPropertyValue(property).trim();
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function ensureSliderGlyph(button, direction) {
    if (!button.classList.contains("wt-slider__nav-btn")) return null;

    let glyph = button.querySelector(".sonic-arrow-control__glyph");
    if (glyph) return glyph;

    glyph = document.createElement("span");
    glyph.className = "sonic-arrow-control__glyph";
    glyph.setAttribute("aria-hidden", "true");

    const svg = document.createElementNS(svgNamespace, "svg");
    svg.classList.add("sonic-arrow-control__svg");
    svg.setAttribute("viewBox", `0 0 ${arrowGeometry.width} ${arrowGeometry.height}`);
    svg.setAttribute("focusable", "false");

    const tail = document.createElementNS(svgNamespace, "line");
    tail.classList.add("sonic-arrow-control__tail");
    tail.setAttribute("x1", direction === -1 ? String(arrowGeometry.prevTipX) : String(arrowGeometry.nextTipX));
    tail.setAttribute("y1", String(arrowGeometry.midY));
    tail.setAttribute("x2", direction === -1 ? String(arrowGeometry.prevTipX) : String(arrowGeometry.nextTipX));
    tail.setAttribute("y2", String(arrowGeometry.midY));

    const head = document.createElementNS(svgNamespace, "path");
    head.classList.add("sonic-arrow-control__head");
    head.setAttribute("d", direction === -1
      ? "M12.71431 14.5714L5.857143 7.7143L12.71431 0.857143"
      : "M5.857143 14.5714L12.71431 7.7143L5.857143 0.857143");

    svg.append(tail, head);
    glyph.append(svg);
    button.append(glyph);

    button.classList.add("sonic-arrow-control--svg");
    button.classList.toggle("sonic-arrow-control--prev", direction === -1);
    button.classList.toggle("sonic-arrow-control--next", direction === 1);
    button.dataset.sonicArrowDirection = String(direction);

    return glyph;
  }

  function setSliderGlyphState(button, gsap, options = {}) {
    const glyph = button.querySelector(".sonic-arrow-control__glyph");
    if (!glyph) return;

    const tail = glyph.querySelector(".sonic-arrow-control__tail");
    const head = glyph.querySelector(".sonic-arrow-control__head");
    if (!tail || !head) return;

    const isActive = Boolean(options.active);
    const direction = Number.parseInt(button.dataset.sonicArrowDirection || "1", 10) === -1 ? -1 : 1;
    const tailLength = getNumericCustomProperty(button, "--sonic-arrow-svg-tail-length", 13);
    const offset = getNumericCustomProperty(button, "--sonic-arrow-svg-offset", 3.07145);
    const opticalShift = getNumericCustomProperty(button, "--sonic-arrow-svg-optical-shift", 0);
    const iconOffset = isActive ? direction * offset : 0;
    const activeOpticalShift = isActive ? -direction * opticalShift : 0;
    const baseTipX = direction === -1 ? arrowGeometry.prevTipX : arrowGeometry.nextTipX;
    const tipX = baseTipX + iconOffset + activeOpticalShift;
    const tailStartX = isActive ? tipX - (direction * tailLength) : tipX;

    gsap.set(head, { x: iconOffset + activeOpticalShift });
    gsap.set(tail, {
      attr: {
        x1: tailStartX,
        x2: tipX,
      },
      opacity: isActive ? 1 : 0,
    });
  }

  function tweenSliderGlyph(button, gsap, active) {
    const glyph = button.querySelector(".sonic-arrow-control__glyph");
    if (!glyph) return;

    const tail = glyph.querySelector(".sonic-arrow-control__tail");
    const head = glyph.querySelector(".sonic-arrow-control__head");
    if (!tail || !head) return;

    const direction = Number.parseInt(button.dataset.sonicArrowDirection || "1", 10) === -1 ? -1 : 1;
    const tailLength = getNumericCustomProperty(button, "--sonic-arrow-svg-tail-length", 13);
    const offset = getNumericCustomProperty(button, "--sonic-arrow-svg-offset", 3.07145);
    const opticalShift = getNumericCustomProperty(button, "--sonic-arrow-svg-optical-shift", 0);
    const iconOffset = active ? direction * offset : 0;
    const activeOpticalShift = active ? -direction * opticalShift : 0;
    const baseTipX = direction === -1 ? arrowGeometry.prevTipX : arrowGeometry.nextTipX;
    const tipX = baseTipX + iconOffset + activeOpticalShift;
    const tailStartX = active ? tipX - (direction * tailLength) : tipX;

    gsap.to(head, {
      x: iconOffset + activeOpticalShift,
      duration: active ? 0.44 : 0.3,
      ease: active ? "expo.out" : "power2.out",
      overwrite: "auto",
    });

    gsap.to(tail, {
      attr: {
        x1: tailStartX,
        x2: tipX,
      },
      opacity: active ? 1 : 0,
      duration: active ? 0.5 : 0.32,
      ease: active ? "expo.out" : "power2.out",
      overwrite: "auto",
    });
  }

  function resetButton(button, gsap, options = {}) {
    const isFooterNewsletterButton = button.classList.contains("wt-newsletter__send");
    const isSliderButton = button.classList.contains("wt-slider__nav-btn");
    const iconWrapper = button.classList.contains("sonic-arrow-button")
      ? button.querySelector(".sonic-arrow-button__icon")
      : button;
    const icon = button.querySelector("svg");
    const target = iconWrapper || button;
    const isActive = Boolean(options.active);
    const iconOffset = options.iconOffset || 0;
    const targetStyles = window.getComputedStyle(target);
    const configuredTailWidth = targetStyles.getPropertyValue("--sonic-arrow-tail-hover-width").trim();

    gsap.set(target, {
      "--sonic-review-tail-width": isActive ? (configuredTailWidth || "12px") : "0px",
      "--sonic-review-tail-opacity": isActive ? 1 : 0,
      "--sonic-review-icon-x": isActive ? `${iconOffset}px` : "0px",
      "--sonic-footer-arrow-stroke": isFooterNewsletterButton && isActive ? "#16181d" : isFooterNewsletterButton ? "#198263" : "currentColor",
    });

    if (icon && !button.classList.contains("sonic-arrow-button") && !isSliderButton) {
      gsap.set(icon, { x: isActive ? iconOffset : 0 });
    }

    if (isSliderButton) {
      setSliderGlyphState(button, gsap, { active: isActive });
    }
  }

  function bindSection(section, gsap) {
    if (!section) return;

    const scopedButtons = section.matches && section.matches(buttonSelector) ? [section] : [];
    const buttons = [...scopedButtons, ...section.querySelectorAll(buttonSelector)];
    if (!buttons.length) return;

    section.dataset.sonicReviewArrows = "true";
    section.classList.add("sonic-review-arrows-gsap");

    buttons.forEach((button) => {
      if (button.dataset.sonicReviewArrowButton === "true") return;

      const icon = button.querySelector("svg");
      const direction = button.classList.contains("wt-slider__nav-prev") ? -1 : 1;
      const isFooterNewsletterButton = button.classList.contains("wt-newsletter__send");
      const isSliderButton = button.classList.contains("wt-slider__nav-btn");
      if (isSliderButton && !button.closest(".wt-product__gallery, [data-section-id$='__product_header_usp_bar']")) return;
      const isArrowButton = button.classList.contains("sonic-arrow-button");
      const iconWrapper = isArrowButton ? button.querySelector(".sonic-arrow-button__icon") : button;
      const target = iconWrapper || button;
      const iconOffset = isFooterNewsletterButton ? 0 : direction * (isArrowButton ? 3 : 4);

      button.dataset.sonicReviewArrowButton = "true";

      if (isSliderButton) {
        button.classList.add("sonic-arrow-control");
        button.classList.toggle("sonic-arrow-control--prev", direction === -1);
        button.classList.toggle("sonic-arrow-control--next", direction === 1);
        ensureSliderGlyph(button, direction);
      }

      resetButton(button, gsap, {
        active: button.matches(":hover") || button.matches(":focus-visible"),
        iconOffset,
      });

      button.addEventListener("mouseenter", () => {
        const targetStyles = window.getComputedStyle(target);
        const configuredTailWidth = targetStyles.getPropertyValue("--sonic-arrow-tail-hover-width").trim();

        gsap.to(target, {
          "--sonic-review-tail-width": configuredTailWidth || "12px",
          "--sonic-review-tail-opacity": 1,
          "--sonic-review-icon-x": `${iconOffset}px`,
          "--sonic-footer-arrow-stroke": isFooterNewsletterButton ? "#16181d" : "currentColor",
          duration: 0.36,
          ease: "power3.out",
          overwrite: "auto",
        });

        if (icon && !isArrowButton && !isSliderButton) {
          gsap.to(icon, {
            x: iconOffset,
            duration: 0.42,
            ease: "power3.out",
            overwrite: "auto",
          });
        }

        if (isSliderButton) {
          tweenSliderGlyph(button, gsap, true);
        }
      });

      button.addEventListener("mouseleave", () => {
        gsap.to(target, {
          "--sonic-review-tail-width": "0px",
          "--sonic-review-tail-opacity": 0,
          "--sonic-review-icon-x": "0px",
          "--sonic-footer-arrow-stroke": isFooterNewsletterButton ? "#198263" : "currentColor",
          duration: 0.28,
          ease: "power2.out",
          overwrite: "auto",
        });

        if (icon && !isArrowButton && !isSliderButton) {
          gsap.to(icon, {
            x: 0,
            duration: 0.32,
            ease: "power2.out",
            overwrite: "auto",
          });
        }

        if (isSliderButton) {
          tweenSliderGlyph(button, gsap, false);
        }
      });
    });
  }

  function prepareSection(section) {
    if (!section) return;

    const scopedButtons = section.matches && section.matches(buttonSelector) ? [section] : [];
    const buttons = [...scopedButtons, ...section.querySelectorAll(buttonSelector)];

    buttons.forEach((button) => {
      if (!button.classList.contains("wt-slider__nav-btn")) return;

      const direction = button.classList.contains("wt-slider__nav-prev") ? -1 : 1;
      button.classList.add("sonic-arrow-control");
      button.classList.toggle("sonic-arrow-control--prev", direction === -1);
      button.classList.toggle("sonic-arrow-control--next", direction === 1);
      ensureSliderGlyph(button, direction);
    });
  }

  function loadAndBind(section) {
    if (!section || section.dataset.sonicReviewArrowsLoading === "true") return;

    if (reduceMotion.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches || !window.sonicLoadGSAP) return;

    section.dataset.sonicReviewArrowsLoading = "true";

    window
      .sonicLoadGSAP()
      .then(({ gsap }) => {
        if (!gsap || !document.body.contains(section)) return;
        bindSection(section, gsap);
      })
      .catch(() => {
        delete section.dataset.sonicReviewArrowsLoading;
      });
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    prepareSection(scope);
    const sections = scope.matches && scope.matches(sectionSelector)
      ? [scope]
      : scope.querySelectorAll(sectionSelector);

    sections.forEach((section) => {
      prepareSection(section);

      section.addEventListener("pointerenter", () => loadAndBind(section), { once: true });

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            loadAndBind(section);
          });
        }, { rootMargin: "300px 0px" });

        observer.observe(section);
      } else {
        loadAndBind(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
